<template>
    <div class="kgr-accordion">
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
    },
    data() {
        return {
        }
    },
    methods: {
    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>
